import React, { useState, useEffect, Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import swal from "sweetalert";
import Layout from "../../components/global/layout";
import methodModel from "../../methods/methods";
import loader from "../../methods/loader";
import ApiClient from "../../methods/api/apiClient";
import SelectDropdown from "../../components/common/SelectDropdown";
import shared from "./Shared";
const emptyForm = {
  title: "",
  image: "",
};

const FormInput = ({
  label,
  name,
  type = "text",
  required,
  options,
  textarea,
  value,
  onChange,
  error,
}) => (
  <div>
    <label className="block text-sm text-gray-700 mb-1">
      {label} {required && <span className="text-red-400">*</span>}
    </label>
    {textarea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        rows={3}
        className={`w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all resize-none ${error ? "border-red-400" : "border-gray-200"}`}
      />
    ) : options ? (
      <select
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all bg-white ${error ? "border-red-400" : "border-gray-200"}`}
      >
        <option value="">Select {label}</option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all ${error ? "border-red-400" : "border-gray-200"}`}
      />
    )}
    {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
  </div>
);

const Equpments = () => {
  const [equpmentListig, setListing] = useState([]);
  const [total, setTotal] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [formErrors, setFormErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: "",
    status: "",
  });

  const fetchEquipment = async (p = {}) => {
    if (!p.search) {
      loader(true);
    }

    try {
      const params = {
        page: p.page ?? filters.page, // ✅ use state
        count: p.count ?? filters.count,
        search: p.search ?? searchQuery,
        status: p.status ?? filters.status,
      };

      const query = new URLSearchParams(params).toString();

      const res = await ApiClient.get(`equipment-type/listing?${query}`);

      if (res?.success) {
        setListing(res?.data?.data || res?.data || []);
        console.log(res?.data, "res?.data");
        setTotal(res.data.total);
      }
    } catch (err) {
      console.error(err);
    }

    loader(false);
  };

  useEffect(() => {
    fetchEquipment();
  }, []);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchEquipment({ search: searchQuery });
    }, 500); // wait 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };
  console.log(form, "form");

  const handleImageChange = (e) => {
    const { files } = e.target;
    const file = files[0];
    if (!file) return;
    if (file.size > 500 * 1024) {
      swal({
        text: "Image size must be less than 500KB",
        icon: "error",
        className: "smallModal",
      });
      return;
    }
    const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    if (!validTypes.includes(file.type)) {
      swal({
        text: "Please upload a valid image (JPG, JPEG, PNG, WEBP)",
        icon: "error",
        className: "smallModal",
      });
      return;
    }
    setImagePreview(URL.createObjectURL(file));
    loader(true);
    ApiClient.postFormData("upload/image", { file }).then((res) => {
      if (res.fileName) setForm((prev) => ({ ...prev, image: res.fileName }));
      loader(false);
    });
  };

  const validate = () => {
    const errors = {};
    if (!form.title.trim()) errors.productName = "Title name is required";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const openAddModal = () => {
    setForm(emptyForm);
    setImagePreview(null);
    setFormErrors({});
    setIsEditMode(false);
    setEditingId(null);
    setIsModalOpen(true);
  };

  const openEditModal = async (id) => {
    loader(true);
    await ApiClient.get(`equipment-type/detail?id=${id}`)
      .then((res) => {
        if (res?.success) {
          const d = res.data;
          setForm({
            title: d.title || "",
            image: d.image || "",
          });
          setImagePreview(d.image ? methodModel.userImg(d.image) : null);
          setFormErrors({});
          setIsEditMode(true);
          setEditingId(id);
          setIsModalOpen(true);
        }
      })
      .catch(console.error);
    loader(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setForm(emptyForm);
    setImagePreview(null);
    setFormErrors({});
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    loader(true);
    const endpoint = isEditMode ? "equipment-type/edit" : "equipment-type/add";
    await ApiClient[isEditMode ? "put" : "post"](
      endpoint,
      isEditMode ? { ...form, id: editingId } : form,
    )
      .then((res) => {
        if (res?.success) {
          swal({
            text: `Equipment ${isEditMode ? "updated" : "added"} successfully.`,
            icon: "success",
            className: "smallModal",
          });
          closeModal();
          fetchEquipment();
        }
      })
      .catch(console.error);
    loader(false);
  };

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "This Equipment will be permanently deleted.",
      icon: "warning",
      className: "smallModal",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) return;
      loader(true);
      await ApiClient.delete(`equipment-type/delete?id=${id}`)
        .then(async (res) => {
          if (res?.success) {
            await fetchEquipment();
            swal({
              text: "Equipment deleted successfully.",
              icon: "success",
              className: "smallModal",
            });
          }
        })
        .catch(console.error);
      loader(false);
    });
  };

  const statusChange = (item, status) => {
    swal({
      title: "Are you sure?",
      text: `Do you want to ${status === "active" ? "active" : "deactive"} this equipment?`,
      icon: "warning",
      className: "smallModal",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) return;

      loader(true);

      try {
        const res = await ApiClient.put(`equipment-type/edit`, {
          id: item._id, // ✅ correct id
          status: status, // active / inactive
        });

        if (res?.success) {
          await fetchEquipment();

          swal({
            text: `Equipment ${status === "active" ? "activated" : "deactivated"} successfully.`,
            icon: "success",
            className: "smallModal",
          });
        }
      } catch (err) {
        console.error(err);
      }

      loader(false);
    });
  };

  const changestatus = (e, key) => {
    setFilter((prev) => ({
      ...prev,
      [key]: e,
      page: 1, // ✅ reset page
    }));

    fetchEquipment({ [key]: e, page: 1 });
  };
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > Math.ceil(total / filters.count)) return;

    setFilter((prev) => ({
      ...prev,
      page: newPage,
    }));
    console.log(newPage);

    fetchEquipment({ page: newPage });
  };
  return (
    <Layout>
      <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
        <div className="flex flex-wrap items-center justify-between gap-2 mb-6">
          <div className="flex flex-col gap-1">
            <h2 className="text-gray-900 text-xl sm:text-2xl font-semibold">
              Equipment
            </h2>
            <p className="text-sm sm:text-md text-gray-600">
              {total} Equipment{total !== 1 ? "s" : ""} total
            </p>
          </div>
          <button
            onClick={openAddModal}
            className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
            Add Equipment
          </button>
        </div>

        <div className="w-full border rounded-2xl bg-white p-5 lg:p-8">
          {/* ─── Filters ─── */}
          <div className="flex justify-between flex-wrap gap-3 mb-4">
            <div className="relative w-full sm:w-[350px]">
              <svg
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <input
                type="text"
                placeholder="Search by title"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full border border-gray-200 rounded-xl pl-9 pr-4 py-2.5 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all"
              />
            </div>

            <div className="flex gap-2 flex-wrap">
              <SelectDropdown
                id="statusDropdown"
                theme="search"
                displayValue="name"
                placeholder="All status"
                intialValue={filters?.status}
                crossIcon={filters?.status ? true : false}
                result={(e) => {
                  changestatus(e.value, "status");
                }}
                isClearable={false}
                options={shared.filterStatus}
              />
            </div>
          </div>

          {/* ───────────────────────────────────────────────────────────── */}
          {/* Mobile Card View */}
          {/* ───────────────────────────────────────────────────────────── */}

          <div className="block md:hidden space-y-4">
            {equpmentListig.length === 0 ? (
              <div className="border border-gray-200 rounded-xl bg-white py-12 px-6">
                <div className="flex flex-col items-center gap-3">
                  <div className="size-14 rounded-full bg-gray-100 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-gray-600"
                    >
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    </svg>
                  </div>

                  <p className="text-sm text-gray-500">No qeupiment found</p>

                  <button
                    onClick={openAddModal}
                    className="text-[#115B9D] text-sm hover:underline"
                  >
                    Add your qeupiment
                  </button>
                </div>
              </div>
            ) : (
              equpmentListig.map((item, index) => (
                <div
                  key={item.id || index}
                  className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex items-center gap-3 flex-1">
                      <div className="size-14 rounded-xl bg-[#115B9D17] border border-[#115B9D]/10 flex items-center justify-center shrink-0">
                        {item.image ? (
                          <img
                            src={methodModel.userImg(item.image)}
                            alt={item.title}
                            className="size-full rounded-xl object-cover"
                          />
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-6 h-6 text-[#115B9D]"
                          >
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                          </svg>
                        )}
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-xs text-gray-500 mb-1">
                          Equipment Name
                        </p>

                        <h3 className="font-semibold text-gray-900 break-words">
                          {item.title}
                        </h3>
                      </div>
                    </div>

                    <div className="shrink-0">
                      {item.status === "active" ? (
                        <span
                          onClick={() => statusChange(item, "deactive")}
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#f0fdf4] text-[#008236] text-xs cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <path d="m9 12 2 2 4-4" />
                          </svg>
                          Active
                        </span>
                      ) : (
                        <span
                          onClick={() => statusChange(item, "active")}
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#1F54FF1A] text-[#2B2B2B] text-xs cursor-pointer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                          </svg>
                          Deactive
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center justify-end gap-2 mt-4 pt-4 border-t border-gray-100">
                    <button
                      type="button"
                      onClick={() => openEditModal(item.id)}
                      title="Edit"
                      className="h-10 w-10 rounded-lg bg-gray-50 hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-[#115B9D] transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                    </button>

                    <button
                      type="button"
                      onClick={() => handleDelete(item.id)}
                      title="Delete"
                      className="h-10 w-10 rounded-lg bg-gray-50 hover:bg-red-50 flex items-center justify-center text-gray-600 hover:text-red-500 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 6h18" />
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 1 2 2 2v2" />
                        <line x1="10" x2="10" y1="11" y2="17" />
                        <line x1="14" x2="14" y1="11" y2="17" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* ───────────────────────────────────────────────────────────── */}
          {/* Desktop Table */}
          {/* ───────────────────────────────────────────────────────────── */}

          <div className="hidden md:block border border-gray-200 rounded-xl overflow-hidden">
            <table className="w-full table-fixed">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="text-left py-3 px-5 w-[140px]">
                    <span className="text-sm text-gray-700 font-[400]">
                      Actions
                    </span>
                  </th>

                  <th className="text-left py-3 px-5">
                    <span className="text-sm text-gray-700 font-[400]">
                      Title
                    </span>
                  </th>

                  <th className="text-left py-3 px-5 w-[160px]">
                    <span className="text-sm text-gray-700 font-[400]">
                      Status
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {equpmentListig.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="text-center py-16">
                      <div className="flex flex-col items-center gap-3">
                        <div className="size-14 rounded-full bg-gray-100 flex items-center justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-gray-600"
                          >
                            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                          </svg>
                        </div>

                        <p className="text-sm text-gray-500">
                          No qeupiment found
                        </p>

                        <button
                          onClick={openAddModal}
                          className="text-[#115B9D] text-sm hover:underline"
                        >
                          Add your qeupiment
                        </button>
                      </div>
                    </td>
                  </tr>
                ) : (
                  equpmentListig.map((item, index) => (
                    <tr
                      key={item.id || index}
                      className="hover:bg-gray-50/60 transition-colors"
                    >
                      {/* Actions */}
                      <td className="py-3 px-5 align-middle">
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => openEditModal(item.id)}
                            title="Edit"
                            className="size-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-[#115B9D] transition-colors"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(item.id)}
                            title="Delete"
                            className="size-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-red-500 transition-colors"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 1 2 2 2v2" />
                              <line x1="10" x2="10" y1="11" y2="17" />
                              <line x1="14" x2="14" y1="11" y2="17" />
                            </svg>
                          </button>
                        </div>
                      </td>

                      {/* Title */}
                      <td className="py-3 px-5">
                        <div className="flex items-center gap-3 min-w-0">
                          <div className="size-10 rounded-xl bg-[#115B9D17] border border-[#115B9D]/10 flex items-center justify-center shrink-0">
                            {item.image ? (
                              <img
                                src={methodModel.userImg(item.image)}
                                alt={item.title}
                                className="size-full object-cover rounded-xl"
                              />
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[18px] h-[18px] text-[#115B9D]"
                              >
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                              </svg>
                            )}
                          </div>

                          <div className="min-w-0 flex-1">
                            <p className="text-sm font-medium text-gray-900 break-words">
                              {item.title}
                            </p>
                          </div>
                        </div>
                      </td>

                      {/* Status */}
                      <td className="py-3 px-5">
                        {item.status === "active" ? (
                          <span
                            onClick={() => statusChange(item, "deactive")}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#f0fdf4] text-[#008236] text-xs cursor-pointer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <path d="m9 12 2 2 4-4" />
                            </svg>
                            Active
                          </span>
                        ) : (
                          <span
                            onClick={() => statusChange(item, "active")}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#1F54FF1A] text-[#2B2B2B] text-xs cursor-pointer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                            </svg>
                            Deactive
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ─── Pagination ─── */}
          {total > filters.count && (
            <div className="flex flex-wrap gap-y-2 gap-x-5 items-center justify-between mt-4">
              <p className="text-sm text-gray-500">
                Showing {(filters.page - 1) * filters.count + 1} to{" "}
                {Math.min(filters.page * filters.count, total)} of {total}
              </p>

              <div className="flex flex-wrap items-center gap-2">
                {/* Prev */}
                <button
                  onClick={() => handlePageChange(filters.page - 1)}
                  disabled={filters.page === 1}
                  className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50"
                >
                  Prev
                </button>

                {/* Page Numbers */}
                {Array.from(
                  { length: Math.ceil(total / filters.count) },
                  (_, i) => i + 1,
                ).map((p) => (
                  <button
                    key={p}
                    onClick={() => handlePageChange(p)}
                    className={`px-3 py-1.5 text-sm rounded-lg ${
                      Number(filters.page) === Number(p)
                        ? "bg-[#115B9D] text-white"
                        : "border"
                    }`}
                  >
                    {p}
                  </button>
                ))}

                {/* Next */}
                <button
                  onClick={() => handlePageChange(filters.page + 1)}
                  disabled={filters.page === Math.ceil(total / filters.count)}
                  className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ─── Add / Edit Modal ─── */}
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-150"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl bg-white rounded-2xl shadow-xl flex flex-col max-h-[90vh]">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 shrink-0">
                    <div className="flex items-center gap-3">
                      <div className="size-9 rounded-xl bg-[#115B9D17] border border-[#115B9D]/10 flex items-center justify-center shrink-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-[18px] h-[18px] font-semibold text-[#115B9D]"
                        >
                          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                        </svg>
                      </div>
                      <Dialog.Title className="text-base font-semibold text-gray-900">
                        {isEditMode ? "Edit ProducEquipment" : "Add Equipment"}
                      </Dialog.Title>
                    </div>
                    <button
                      onClick={closeModal}
                      className="size-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-gray-600 transition-colors"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 6 6 18M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="px-6 py-5 overflow-y-auto flex-1 space-y-5 scrollbar">
                    <div className="space-y-1">
                      {/* <p className="text-xs font-semibold text-gray-600 uppercase tracking-widest">Product Info</p> */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                        <div className="sm:col-span-2">
                          <FormInput
                            label="Title"
                            name="title"
                            required
                            value={form.title}
                            onChange={handleChange}
                            error={formErrors.title}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Image Upload */}
                    <div>
                      <label className="block text-sm text-gray-700 mb-2">
                        Product Image
                      </label>
                      <label className="cursor-pointer">
                        <div
                          className={`relative border-2 border-dashed rounded-xl p-6 text-center transition-all ${
                            imagePreview
                              ? "border-[#115B9D] bg-[#115B9D17]"
                              : "border-gray-200 hover:border-[#115B9D] hover:bg-[#115B9D17]"
                          }`}
                        >
                          {imagePreview ? (
                            <div className="flex items-center gap-4">
                              <img
                                src={imagePreview}
                                alt="Preview"
                                className="size-16 rounded-xl object-cover border border-gray-200"
                              />
                              <div className="text-left">
                                <p className="text-sm text-gray-700 font-medium">
                                  Image selected
                                </p>
                                <p className="text-xs text-gray-600 mt-0.5">
                                  Click to change
                                </p>
                                <p className="text-xs text-gray-600">
                                  Max 500KB · JPG, PNG, WEBP
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className="flex flex-col items-center gap-2">
                              <div className="size-10 rounded-full bg-[#115b9d29] flex items-center justify-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="text-[#115B9D]"
                                >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                  <polyline points="17 8 12 3 7 8" />
                                  <line x1="12" x2="12" y1="3" y2="15" />
                                </svg>
                              </div>
                              <p className="text-sm text-[#115B9D]">
                                Click to upload image
                              </p>
                              <p className="text-xs text-gray-600">
                                Max 500KB · JPG, JPEG, PNG, WEBP
                              </p>
                            </div>
                          )}
                          <input
                            type="file"
                            className="hidden"
                            accept="image/jpeg,image/jpg,image/png,image/webp"
                            onChange={handleImageChange}
                          />
                        </div>
                      </label>
                    </div>

                    <div className="h-2" />
                  </div>

                  {/* Modal Footer */}
                  <div className="flex flex-wrap items-center justify-end gap-2 px-6 py-4 border-t rounded-b-2xl border-gray-100 bg-gray-50/60 shrink-0">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="inline-flex items-center gap-2 text-sm text-gray-600 hover:opacity-80 rounded-xl transition-colors border border-gray-200 bg-white font-medium px-5 py-2.5"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleSubmit}
                      className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        {isEditMode ? (
                          <>
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </>
                        ) : (
                          <path d="M12 5v14M5 12h14" />
                        )}
                      </svg>
                      {isEditMode ? "Update Equipment" : "Add Equipment"}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </Layout>
  );
};

export default Equpments;
